export const products = [
  {
    id: 1,
    name: "AURA 01",
    price: 185,
    tag: "NEW DROP",
    description: "Ultra-lightweight titanium frame with signature prism-etched temples.",
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1577803645773-f96470509666?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 2,
    name: "VOID FRAME",
    price: 220,
    tag: "BESTSELLER",
    description: "Matte black acetate, oversized silhouette for a bold architectural statement.",
    image: "https://images.unsplash.com/photo-1574258495973-f010dfbb5371?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1509695507497-903c140c43b0?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 3,
    name: "SPECTRA",
    price: 195,
    tag: "LIMITED",
    description: "Translucent crystalline frames that catch and refract ambient light.",
    image: "https://images.unsplash.com/photo-1589642380614-4a8c2147b857?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1572402230267-f3e2e58c105b?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 4,
    name: "CORE X",
    price: 150,
    tag: "ESSENTIAL",
    description: "The daily standard. Ergonomic fit with high-impact resistant lenses.",
    image: "https://images.unsplash.com/photo-1625591340244-b010c283842c?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1625591339794-681b95b8d00c?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 5,
    name: "PRISM V01",
    price: 245,
    tag: "STUDIO EXCLUSIVE",
    description: "Hand-finished edges with custom gradient-tinted performance optics.",
    image: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1508296695146-257a814070b4?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: 6,
    name: "NEON DRIFT",
    price: 210,
    tag: "TRENDING",
    description: "Vibrant accents paired with industrial-grade hinges for active lifestyles.",
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&q=80&w=800",
    hoverImage: "https://images.unsplash.com/photo-1577803645773-f96470509666?auto=format&fit=crop&q=80&w=800"
  }
];

export const reviews = [
  { id: 1, author: "Alex M.", text: "The prism lenses literally change how I see the city. Incredible clarity and the frame weight is negligible.", rating: 5 },
  { id: 2, author: "Sam K.", text: "Stark, bold, unapologetic design. The fit guide was spot on for my square face shape.", rating: 5 },
  { id: 3, author: "Jordan T.", text: "Build quality is insane. The hinges feel like a bank vault and the finish is flawless.", rating: 5 }
];

export const faqs = [
  { q: "What are Prism lenses?", a: "Our proprietary lens technology that dynamically shifts tint based on UV exposure while maintaining perfect color accuracy across the visible spectrum." },
  { q: "Do you offer prescription lenses?", a: "Yes. Simply upload your prescription after purchase. We handle single vision, progressive, and specialized blue-light filters." },
  { q: "What is your return policy?", a: "30 days, no questions asked. We provide a pre-paid shipping label for all returns to ensure a seamless experience." }
];